// Copy for one assistant reply (site-assistant SA22): text/html from the rendered
// subset, so a paste into Gmail or Docs keeps bullets and bold, and text/plain
// without markdown syntax, so a paste into a plain field reads cleanly. Falls back
// to plain text where ClipboardItem is unavailable.

import { markdownToPlainText } from "./markdown.js";

/** The rendered reply without the site's classes, with links made absolute so they still work after pasting. */
function clipboardHtml(body: HTMLElement): string {
  const clone = body.cloneNode(true) as HTMLElement;
  clone.querySelectorAll("[class]").forEach((el) => el.removeAttribute("class"));
  clone.querySelectorAll("a[href]").forEach((a) => {
    a.setAttribute("href", new URL(a.getAttribute("href")!, window.location.origin).href);
  });
  return clone.innerHTML;
}

export async function copyReply(markdown: string, body: HTMLElement | null): Promise<void> {
  const plain = markdownToPlainText(markdown);
  if (body && typeof ClipboardItem !== "undefined" && typeof navigator.clipboard?.write === "function") {
    try {
      await navigator.clipboard.write([
        new ClipboardItem({
          "text/html": new Blob([clipboardHtml(body)], { type: "text/html" }),
          "text/plain": new Blob([plain], { type: "text/plain" }),
        }),
      ]);
      return;
    } catch {
      // Some browsers refuse text/html; plain text below still works.
    }
  }
  await navigator.clipboard.writeText(plain);
}
